import * as React from 'react';
import core, { App } from '@gin-betting/core';

import ProgressLine from './ProgressLine';

const { withPure } = core.hocs;

interface OwnProps {
    initialProgressValue: number;
    fetchStatus: App.FetchStatus;
}

interface State {
    progressValue: number;
    isVisibleProgressBar: boolean;
}

type Props = OwnProps;

class Loader extends React.Component<Props, State> {
    timerInterval: number;
    timerDelay: number;
    progressbarStep: number = 2;
    delay: number = 1500;
    interval: number = 500;

    state: State = {
        progressValue: this.props.initialProgressValue,
        isVisibleProgressBar: false,
    };

    componentDidMount() {
        const { fetchStatus, initialProgressValue } = this.props;

        if (fetchStatus === App.FetchStatus.LOADING && !this.timerInterval) {
            this.startProcessing(initialProgressValue);
        }
    }

    UNSAFE_componentWillReceiveProps(nextProps: Props) {
        if (nextProps.fetchStatus === App.FetchStatus.LOADING) {
            clearInterval(this.timerInterval);
            clearTimeout(this.timerDelay);

            this.startProcessing(nextProps.initialProgressValue);
        } else {
            clearInterval(this.timerInterval);

            this.setState({ progressValue: 100 });

            this.timerDelay = window.setTimeout(
                () =>
                    this.setState({
                        progressValue: this.props.initialProgressValue,
                        isVisibleProgressBar: false,
                    }),
                this.delay
            );
        }
    }

    componentWillUnmount() {
        clearInterval(this.timerInterval);
        clearTimeout(this.timerDelay);
    }

    startProcessing = (initialProgressValue: number) => {
        this.setState(
            { progressValue: initialProgressValue },
            /*callback used `cause we need to be sure that value is set to initial */
            this.changeProgressValue
        );

        this.timerInterval = window.setInterval(() => {
            this.changeProgressValue();
        }, this.interval);
    };

    changeProgressValue = () => {
        /* eslint-disable react/no-access-state-in-setstate */
        const nextValue = this.state.progressValue + this.progressbarStep;

        if (nextValue < 100)
            this.setState({
                progressValue: nextValue,
                isVisibleProgressBar: true,
            });
        /* eslint-enable */
    };

    render() {
        return this.state.isVisibleProgressBar ? (
            <ProgressLine percent={this.state.progressValue} />
        ) : null;
    }
}

export default withPure(Loader);
